import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { submitPayment } from "../actions/productActions";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { use } from "react";
const PaymentStatus = (props) => {
  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const refNumber = searchParams.get("reference_number");
  const isRapyd = searchParams.get("is_rapyd");
  const status = searchParams.get("status");

  const [PaymentData, setRapidPaymentData] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [transactionId, settransactionId] = useState(0);
  // const amountRounding = localStorage.getItem('amount_rounding_method') === undefined
  //   ? null
  //   : localStorage.getItem('amount_rounding_method');
  // const isInclusiveGST = localStorage.getItem("apply_inclusive_gst") === "true"

  //OUTLETS AND DELIVERY CHARGE STATES **************************
  let date = new Date()
  date = new Date(date.toLocaleString("en-us", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }))
  let currentDate = date.toISOString().split("T")[0]
  let currentTime = date.toLocaleString("en-us", { hour: "numeric", minute: "numeric", hour12: true })

  let deliveryInformation
  if (localStorage.deliveryInformation) {
    deliveryInformation = JSON.parse(localStorage.deliveryInformation)
  }

  async function rapidPaymentPayload() {
    try {
      const response = await axios.post("update_rapidpayorder_status", { "order_id": refNumber, "status": status });
      const result = response?.data;
      return response;
    } catch (err) {
      console.error("rapidPaymentPayload:", err);
      return null;
    }
  }

  useEffect(() => {
    const fetchPaymentData = async () => {
      const rapidPaymentData = await rapidPaymentPayload();
      if (!rapidPaymentData || rapidPaymentData?.data?.errorMessage === 'Order Not Found') {
        toast.error(rapidPaymentData?.data?.errorMessage);
        history.push("/");
      } else if (rapidPaymentData?.data?.errorMessage === 'Order Already Processed') {
        toast.error(rapidPaymentData?.data?.errorMessage)
        history.push(
          `/?business_id=${rapidPaymentData.data.data.business_id}&location_id=${rapidPaymentData.data.data.location_id}`
        );
      }
      setRapidPaymentData(rapidPaymentData?.data ?? null);
    };

    fetchPaymentData();
  }, []);

  useEffect(() => {
    if (!PaymentData) return;

    const statusSuccess = status === "completed" || status === "succeeded";

    if (statusSuccess && refNumber && isRapyd) {
      saveOrder(PaymentData);
      // setSuccess(true)
      // return
    } else {
      setSuccess(false);
      setLoading(false);
    }
  }, [status, refNumber, isRapyd, PaymentData]);

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const saveOrder = async (PaymentData) => {
         PaymentData = JSON.parse(PaymentData?.data)
    // PaymentData = JSON.parse(PaymentData?.data)
    // let GOVT_TAX = ["GST", "SST"];
    // const gstDetail = PaymentData?.tax?.filter(i => GOVT_TAX.includes(i.name))?.[0];
    // // const orderType = parseInt(localStorage.getItem("order_type"))
    // const payload = {
    //   business_id: PaymentData?.business_id,
    //   user_id: PaymentData?.user?.data?.user?.user_id,
    //   location_id: PaymentData?.location_id,
    //   contact_id: PaymentData?.user?.data?.user?.contact_id,
    //   type: "sell",
    //   type_for_api: PaymentData?.order_type === 1 ? "Delivery" : "Pickup",
    //   products: PaymentData.products, //JSON.parse(localStorage.getItem("products"))[0],
    //   discount_type: "percentage",
    //   discount_amount: 0,
    //   sell_price_tax: "includes",
    //   tax_rate_id: gstDetail?.id,
    //   tax_calculation_amount: gstDetail?.amount,
    //   payment: [
    //     {
    //       amount: PaymentData?.serviceFee?.cart_sum_price,
    //       method: "card",
    //       card_type: isRapyd ? "Rapyd" : "Hitpay PayNow",
    //     },
    //   ],
    //   total_before_tax: PaymentData?.serviceFee?.delivery_fee + PaymentData?.serviceFee?.small_order_fee,
    //   final_total: parseFloat(PaymentData?.serviceFee?.cart_sum_price),
    //   amount_rounding_method: PaymentData?.amount_rounding_method || 0,
    //   round_off_amount: PaymentData?.round_off_amount || 0,
    //   status: "final",
    //   gender: PaymentData?.user?.data.user.gender === "Male" ? 1 : 0,
    //   phone: PaymentData?.user?.data.user?.contactNo,
    //   email: PaymentData?.user?.data.user?.email,
    //   accept_term_and_cond: 1,
    //   occasional_offers: 0,
    //   pickup_completed: 0,
    //   delivery_charges: PaymentData?.serviceFee?.delivery_fee,
    //   small_order_fee: PaymentData?.serviceFee?.small_order_fee,
    //   is_inclusive_gst_applied: PaymentData?.is_inclusive_gst_applied || false,
    //   platform: "foodDelivery",
    //   order_platform: "foodDelivery",
    //   d_address: PaymentData.order_type === 1 ? PaymentData.deliveryInformation.customerAddress : "",
    //   d_date: PaymentData.order_type === 1 ? currentDate : PaymentData.pickup_information.date,
    //   d_time: PaymentData.order_type === 1 ? currentTime : PaymentData.pickup_information.time,
    //   outlet: PaymentData?.orderType === 1
    //     ? PaymentData.deliveryInformation?.deliveryOutId
    //     : PaymentData.pickup_information.out_id,
    // };

    // try {
    //   const res = await axios.post("/save_pickup_delivery", payload, {
    //     headers: { "Content-Type": "application/json" },
    //   });
    //   // props.submitPayment(res.data);
      localStorage.removeItem("cart");
      settransactionId(PaymentData.order_id)
      localStorage.removeItem("login");
      localStorage.removeItem('business_id');
      localStorage.removeItem('location_id');
      localStorage.removeItem('verifiedEmail');
      localStorage.removeItem("deliveryInformation");

      const userDetails = PaymentData?.user?.data?.user;

      const resultData = {
        data: {
          user: {
            username: userDetails.username,
            email: userDetails.email,
            fname: userDetails.fname,
            lname: userDetails.lname,
            surname: userDetails.surname,
            dob: userDetails.dob,
            gender: userDetails.gender,
            contact_id: userDetails.contact_id,
            contactNo: userDetails.contactNo,
            address: userDetails.address,
            city: userDetails.city,
            zip: userDetails.zip,
            country: userDetails.country,
            user_id: userDetails.user_id
          },
          token: PaymentData?.user.data.token,
          token_expired_at: PaymentData?.user.data.token_expired_at
        }
      }

    //   if (res?.data) {
        localStorage.setItem("login", true);
        localStorage.setItem('business_id', PaymentData?.business_id);
        localStorage.setItem('location_id', PaymentData?.location_id);
        // localStorage.setItem('verifiedEmail', 1);//PaymentData?.data?.user?.email);
        localStorage.setItem("headers", JSON.stringify(resultData));
    //   }

    //   if (PaymentData?.order_type === 1) {
    //     const data = {
    //       "transaction_id": res.data.transaction_id,
    //       "business_id": PaymentData?.business_id,
    //       "outlet_lat": PaymentData.deliveryInformation.deliveryOutLat,
    //       "outlet_lng": PaymentData.deliveryInformation.deliveryOutLong,
    //       "outlet_add": PaymentData.deliveryInformation.deliveryOutAddress,
    //       "cust_lat": PaymentData.deliveryInformation.customerLat ?? 0,
    //       "cust_lng": PaymentData.deliveryInformation.customerLong ?? 0,
    //       "cust_add": PaymentData.deliveryInformation.customerAddress,
    //       "cust_name": PaymentData.deliveryInformation.customerName,
    //       "cust_phone": PaymentData.deliveryInformation.customerPhone,
    //       "cust_remark": PaymentData.deliveryInformation.note,
    //       "quoted_fee": PaymentData.deliveryInformation.deliveryCharge ?? 0,
    //       "quoted_currency": PaymentData.deliveryInformation.deliveryCurrency ?? "SGD",
    //       "location_id": PaymentData?.location_id,
    //       "qutotaioId": PaymentData.deliveryInformation.deliveryQuotationId,
    //       "stopId": PaymentData.deliveryInformation.deliveryStopIdOne,
    //       "stopIdTwo": PaymentData.deliveryInformation.deliveryStopIdTwo
    //     }
    //     try {
    //       let hitlalamo = await axios.post("/order/place", data);

    //       let kitchenData = {
    //         invoice_no: res.data.invoice_no,
    //         check_no: res.data.check_no,
    //         order_token_no: res.data.order_token_no,
    //         orderType: PaymentData?.order_type === 1 ? "Delivery" : "Pickup",
    //         type: "kitchen",
    //         message: "",
    //         isMoveItems: false,
    //         isVoid: false,
    //         receipt_type: "Kitchen Receipt",
    //         received_time: moment().format("YYYY-MM-DD HH:mm:ss"),
    //       }

    //       const kitchenPrintpaylod = {
    //         transaction_id: res.data.transaction_id,
    //         receipt_type: "",
    //         device_id: "",
    //         user_id: PaymentData?.user?.data?.user?.user_id,
    //         business_id: PaymentData?.business_id,
    //         business_location_id: PaymentData?.location_id,
    //         location_id: PaymentData?.location_id,
    //         terminal_id: "",
    //         order_type: PaymentData?.order_type,
    //         json_data: JSON.stringify(kitchenData),
    //         status: "",
    //       }
    //       // console.log("lalaMoSTATUS", hitlalamo);
    //       try{
    //         let kitchenPrint = await axios.post("send_order_print_request_terminal", kitchenPrintpaylod);
    //         if(kitchenPrint?.data?.status === "failed"){
    //           alert("Kitchen Print Failed");
    //           throw new Error(kitchenPrint.data.message);
    //         }
    //       }catch(e){
    //         console.error("Kitchen Print Error:", e);
    //         alert("Kitchen Print Failed");
    //       }
    //       if (
    //         hitlalamo?.data?.errors ||
    //         hitlalamo?.data?.errorMessage ||
    //         hitlalamo?.data?.error
    //       ) {
    //         toast.error(
    //           hitlalamo?.data?.errorMessage ||
    //           "Delivery scheduling failed. Please try again."
    //         );
    //         history.push(
    //           `/?business_id=${PaymentData?.business_id}&location_id=${PaymentData?.location_id}`
    //         );
    //         return;
    //       }
    //     } catch (err) {
    //       toast.error("Delivery scheduling failed. Please try again.");
    //       history.push(
    //         `/?business_id=${PaymentData?.business_id}&location_id=${PaymentData?.location_id}`
    //       );
    //       return;
    //     }
    //   }
    setSuccess(true);
        setLoading(false)
      setTimeout(() => {
        history.push("/track-order/");
      }, 5000);

    //   setSuccess(true);
    // } catch (err) {
    //   console.error("Save order error:", err);
    //   setSuccess(false);
    // } finally {
    //   setLoading(false);
    // }
  };

  if (loading) {
    return <p style={{ textAlign: "center" }}>Processing payment...</p>;
  }

  return (
    <div
      style={{
        padding: "30px",
        textAlign: "center",
        width: "90%",
        borderRadius: "10px",
        background: "#fff",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        margin: "50px auto",
      }}
    >
      {success ? (
        <>
          <img alt="Payment Success" height={170} src="/images/tick.png" width={170} />
          <h2 style={{ color: "green" }}>Payment Successful</h2>
          <p>
            Thank you, your payment was processed successfully.
            <br />
            <strong>Order ID:</strong> {transactionId}
          </p>
        </>
      ) : (
        <>
          <img alt="Payment Failed" height={170} src="/images/cross.jpg" width={170} />
          <h2 style={{ color: "red" }}>Payment Failed</h2>
          <p>Sorry, your payment could not be processed.</p>
        </>
      )}
      {/* 
      {PaymentData && (
        <button
          onClick={() =>
            history.push(
              `/?business_id=${PaymentData?.user?.data?.user?.business_id}&location_id=${PaymentData?.user?.data?.user?.location_id}`
            )
          }
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "6px",
            border: "none",
            background: "#007bff",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          
        </button>
      )} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  order: state.products.order,
});

// export default PaymentStatus;
export default withTranslation()(
  connect(mapStateToProps, { submitPayment })(PaymentStatus)
)
